import React, { createContext, useState, useContext, ReactNode } from "react";

interface NavContextValue {
  isNavOpen: boolean;
  openNav: () => void;
  closeNav: () => void;
  toggleNav: () => void;
}

const NavContext = createContext<NavContextValue | undefined>(undefined);

export const NavProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const openNav = () => setIsNavOpen(true);
  const closeNav = () => setIsNavOpen(false);
  const toggleNav = () => setIsNavOpen((prev) => !prev);

  return (
    <NavContext.Provider value={{ isNavOpen, openNav, closeNav, toggleNav }}>
      {children}
    </NavContext.Provider>
  );
};

// Hook personnalisé pour facilement utiliser le contexte
export const useNav = (): NavContextValue => {
  const context = useContext(NavContext);
  if (!context) {
    throw new Error("useNav must be used within a NavProvider");
  }
  return context;
};
